import React from 'react';

import LoginForm from './login';
import PopUp from "../base/popup";
import ForgotPassword from "./forgotPassword";


class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {email: "", errors: {}},
            isLoading: false,
        };

        this.forgotPasswordPopup = React.createRef();
    }

    onClickForgotPassword = () => {
      this.forgotPasswordPopup.current.open();
    };

    onCloseForgotPassword = () => {
        this.forgotPasswordPopup.current.close();
    };


    render() {
        return (<React.Fragment>
                <LoginForm user={this.state.user}
                           onClickForgotPassword={this.onClickForgotPassword}
                           saveAnswers={true} continue_path={this.props.continue_path} />

            <PopUp ref={this.forgotPasswordPopup}>
                <ForgotPassword onClose={this.onCloseForgotPassword} />
            </PopUp>
        </React.Fragment>)
    }



}
export default Index;